import React from "react";
import cn from "classnames";
import styles from "./Panel.module.sass";
import AccessControl from "../../../../../../../HOC/AccessControl";

const Panel = ({ onCreateClick, onPrintAllClick }) => {
  return (
    <>
      <div className={cn("panel", styles.panel)}>
        <div className={styles.info}></div>
        <div className={styles.btns}>
          <AccessControl moduleCode="FvrVqN" requiredPrivilege="cifHqu">
            <button
              className={cn("button-stroke", styles.button)}
              onClick={onPrintAllClick}
            >
              Download All
            </button>
          </AccessControl>
          <AccessControl moduleCode="FvrVqN" requiredPrivilege="cifHqu">
            <button
              className={cn("button", styles.button)}
              onClick={onCreateClick}
            >
              Add Barcode
            </button>
          </AccessControl>
        </div>
      </div>
    </>
  );
};

export default Panel;
